import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities, TimeSeriesProviders } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class TimeSeriesApiService {
  private tsQuery: any;

  constructor(private REQ: RequestService) {
    this.tsQuery = {
      params: {
        provider: 'instrument',
      },
      user_data: {
        authority: authorityIds.TS,
        sub_authority: subAuthorities.TIME_SERIES.DETAILS,
        operation: operations.VIEW,
        data: 'NA',
      },
    };
  }

  fetchInstrumentTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.Instrument;
    return this.REQ.get('timeseries/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchPortfolioTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.Portfolio;
    return this.REQ.get('timeseries/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchLiabilitiesTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.Liabilities;
    return this.REQ.get('timeseries/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchAssetTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.Asset;
    return this.REQ.get('timeseries/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchOSMAAccountTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.Account;
    return this.REQ.get('osma/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchOSMAAdvisorTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.Advisor;
    return this.REQ.get('osma/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchOSMAAccountAssetTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.AccountAsset;
    return this.REQ.get('osma/info', { query: JSON.stringify(this.tsQuery) });
  }

  fetchOSMAAdvisorAssetTSInfo(): Observable<any> {
    this.tsQuery.params.provider = TimeSeriesProviders.AdvisorAsset;
    return this.REQ.get('osma/info', { query: JSON.stringify(this.tsQuery) });
  }
}
